/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Divider, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { AUTH_STRINGS } from '../../../../../constants/strings';
import FxCard from '../../../../Container/FxCard';
import FxCardBody from '../../../../Container/FxCardBody';
import FxCardFooter from '../../../../Container/FxCardFooter';
import { FxTextEdit } from '../../../../Input/FxText/FxTextEdit';
import FxLabelView from '../../../../Input/FxLabel/FxLabelView';
import { FxButton } from '../../../../Action/FxButton';
import usa_state from '../../../../Utils/usa_states.json'
import { deleteUnwantedRequest, handleKeyDownChange, handleZipChange, handleAddressChange, setZipValidationOptions, setPhoneValidationOptions, convertToPhoneRequestFormat, setSsnValidationOptions, setItinValidationOptions, ShowInfoToolTip, handleFieldChange, handleDateValidation, handleEmailChange, setCityValidation, fetchDataFromState, convertToPhoneDisplayFormat, isNullOrUndefined } from '../../../../Utils/CommonBaseClass';
import { FxDateEdit } from '../../../../Input/FxDate/FxDateEdit';
import FxPhoneEdit from '../../../../Input/FxPhone/FxPhoneEdit';
import { FxTextEditSSN } from '../../../../Input/FxSSN/FxTextEditSSN';
import { FxSelectAutoSearch } from '../../../../Input/FxSelect/FxSelectAutoSearch';
import FxMaterialSelect from '../../../../Input/FxSelect/FxMaterialSelect';
import { FieldErrorMessageRender } from '../../Common/FieldErrorMessageRender';
import { saveNodeData } from '../../../../../libs/utils/autoSaveField';
import { useDispatch, useSelector } from 'react-redux';
import { useIsMobileOrTabletScreen } from '../../../../../libs/utils/utils';

//component used to edit joint tenacny co owner

export const JointTenancyCoOwnerEdit: React.FC<any> = React.memo(
    (props) => {
        const isSmallScreen = useIsMobileOrTabletScreen();
        const { register, formState: { errors }, handleSubmit, setValue, control, clearErrors, setError, watch, getValues } = useForm({mode: 'onChange',reValidateMode:'onChange'});       
        const [checkBoxValue, setCheckBoxValues] = useState<any>({ creditReport: false })
        const [businessOwnerDetails, setBusinessOwnerDetails] = useState<any>();
        const dispatch = useDispatch();
        const defaultTaxIdentifier = props?.data?.itin ? 'itin' : 'ssn';
        const taxIdentifier = watch('taxIdentifier') || defaultTaxIdentifier;
        const taxIdentifierData = [
            { label: "SSN", value: "ssn" },
            { label: "ITIN", value: "itin" },
        ];
        /**
        * Function to be called before loading the component
        */
        useEffect(() => {
            if (props.data) {
                setBusinessOwnerDetails(props?.data);               
                setCheckBoxValues({ creditReport: props?.data?.creditReport === undefined ? false : props?.data?.creditReport === 'creditReport' ? true : props?.data?.creditReport ? props?.data?.creditReport : false })
            }
        }, [props?.data]);              


        // let creditReportCheckBoxData = [
        //     { label: 'Pull Credit Report', value: 'creditReport', checked: checkBoxValue?.creditReport }
        // ]

        // Email validation constant
        const setEmailValidationOptions = {
            required: true,
            maxLength: 250,
            pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,40}$/i,
                message: AUTH_STRINGS.ERRORS.EMAIL_INVALID_REGEXP,
            },
        };

        // Method handles the submit for edit beneficial owner form
        function onSubmit(data: any) {
            // If 'ssn' is being used, remove 'itin' from the data.
            // Otherwise, if 'itin' is being used, remove 'ssn' from the data
            if (taxIdentifier === 'ssn') {
                data.ssn = data?.ssn || businessOwnerDetails?.ssn;
            } else {
                data.itin = data?.itin || businessOwnerDetails?.itin;
            }
            delete data['taxIdentifier'];
            const req: any = { ...data };
            if (data['id'] === '') {
                delete data['id'];
                delete req['id'];
            }
            if (data['dob']) {
                req['dob'] = moment(data['dob']).format('MM/DD/YYYY');
            }
            const address: any = {
                "addressLine1": data['addressLine1'],
                "addressLine2": data['addressLine2'],
                "city": data['city'],
                "state": data['state'],
                "zip": data['zip'],
                "isPrimary": true,
            }
            if (data['address_id']) {
                address['id'] = data['address_id'];
            }
            req['mailingAddress'] = [address]
            req.portalAccess = {
                grantAccess: true
            };
            
            req['mobilePhone'] = convertToPhoneRequestFormat(req.mobilePhone)
            if (req['mobilePhone'] === "") {
                delete req['mobilePhone'];
            }

            // req = clean(req);
            const unwantedRequestArray = ['state', 'addressLine1', 'city', 'zip', 'addressLine2', 'creditReport','mobilePhone-select'];
            deleteUnwantedRequest(req, unwantedRequestArray)
            if (props.onSubmit) {
                props.onSubmit(data, req, 'edit', props?.index)
            }
            if (props?.cancel) {
                props.cancel()
            }
        }

        // Method handles the click operation for going back to business owner list screen
        const handleGoBackClick = () => {
            if (props?.cancel) {
                props.cancel()
            }
        }
        /**
        *  Address line 1 validation constant
        * */
        const setAddressLine1Validation = {
            required: true,
            minLength: {
                value: 4,
                message: AUTH_STRINGS.ERRORS.ADDRESS_LINE_1_LENGTH_VALIDATION
            },
            maxLength: {
                value: 40,
                message: AUTH_STRINGS.ERRORS.ADDRESS_LINE_1_LENGTH_VALIDATION
            }
        }

        /**
        * Error messages for Date of Birth (DOB) validation:
        * - futureDate: Error if the DOB is a future date (not allowed)
        * - maxDate: Error if the DOB indicates the user is less than 18 years old
        * - minDate: (optional) Error if the DOB is before a very old date (not needed here)
        */ 
        const dobErrorMsg = {
            futureDate: AUTH_STRINGS.ERRORS.JOINT_TENANCY_FUTURE,
            maxDate: AUTH_STRINGS.ERRORS.JOINT_TENANCY_LESS_THAN_18,
        }

        /**
         * Method fetches data from the state
         */
        const jointOwnerState = useSelector((state: any) =>
            fetchDataFromState(state, 'customer-kyc-joint-owners-data')
        );

        /**
         * Handles auto-saving of a single form field.
         *
         * This function delegates the save logic to `saveNodeData`, passing in the current field name and value,
         * along with necessary form and state management functions like `setValue`, `getValues`, `dispatch`,
         * and the `individualState`. This ensures that field changes are persisted automatically.
         *
         * @param fieldName - The name of the field being updated.
         * @param value - The new value to be saved.
        */
        const handleAutoSave = (fieldName: string, value: any) => {
            saveNodeData('coowner-info-page', fieldName, value, setValue, getValues, dispatch, jointOwnerState, props?.apiIndex);
        }

        /**
         * Handling the onChange events on the DOB field
         * @param value 
         */
        const handleDOBOnChangeEvents = (value: any) => {
            handleDateValidation("dob", value, setValue, setError, clearErrors, true, moment(),null,dobErrorMsg);
            isNullOrUndefined(errors?.dob) && handleAutoSave("dob", value);
        }

        /**
         * this method handles the onChange events on the State Field
         * @param e 
         * @param fieldName 
         */
        const handleStateOnChangeEvents = (e: any, fieldName: string) => {
            handleFieldChange('state', e, setValue, clearErrors);
            handleAutoSave(fieldName, e);
        }

        return (
            <Grid container id='signUp-business-owner' xs={12}>
                <FxCard id="signUp-business-owner-form-card" className="fx-info-kyc-edit">
                    <div className="fx-form-edit-profile">
                        {businessOwnerDetails !== undefined && <form id="signUp-business-owner-form" onSubmit={handleSubmit(onSubmit)}>
                            <FxCardBody id="signUp-business-owner-form-card-body" className="fx-info-card" >
                                <Grid container direction="row" spacing={2} className="fx-info-card-form" >
                                    <FxTextEdit register={{ ...register("id") }} className={"fx-hidden"} control={control} rules={{ required: false }} id="signUp-business-owner-form-card-first-name" name="id" variant="outlined" defaultValue={businessOwnerDetails?.id} />
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("firstName") }} className={errors.firstName ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-first-name" label="First Name" name="firstName" variant="outlined" defaultValue={businessOwnerDetails?.firstName}  
                                        onBlur={(e) => handleAutoSave('firstName', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='firstName'/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("middleName") }} className={errors.lastname ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: false }} id="signUp-business-owner-form-card-middle-name" label="Middle Name (optional)" name="middleName" variant="outlined" defaultValue={businessOwnerDetails?.middleName} 
                                        onBlur={(e) => handleAutoSave('middleName', e)}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("lastName") }} className={errors.lastname ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: false }} id="signUp-business-owner-form-card-last-name" label="Last Name" name="lastName" variant="outlined" defaultValue={businessOwnerDetails?.lastName} 
                                         onBlur={(e) => handleAutoSave('lastName', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='lastName'/>
                                    </Grid>

                                    <Grid item sm={12} xs={12}>
                                        <FxDateEdit register={{ ...register("dob") }} className={errors.dob ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={{ required: true }} id="signUp-business-owner-form-card-dob" label="Date of Birth" name="dob" variant="outlined" value={businessOwnerDetails?.dob} maxDate={moment()}  setValue={setValue}  onChange={(value) => handleDOBOnChangeEvents(value)} ageLimitMessage={dobErrorMsg.maxDate} futureDateMessage={dobErrorMsg.futureDate}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='dob' type='date'/>
                                    </Grid>

                                    {/*** Identification Info Fields ***/}
                                    <Grid container item xs={12} sm={12} display={'flex'} >
                                        <Grid item >
                                            <FxLabelView id="business-owner-details-label" className="" >IDENTIFICATION INFO</FxLabelView>
                                        </Grid>
                                        <Grid item xs={1} container justifyContent="center" alignItems="center">
                                            {ShowInfoToolTip('fx-business-owner-title-tooltip', 'To keep your account secure, we need to verify some details. This helps us ensure a safe and compliant experience for you.', 'right')}
                                        </Grid>
                                    </Grid>
                                    
                                    <Grid item xs ={12} sm={12}>
                                        <FxMaterialSelect
                                            register={{ ...register("taxIdentifier") }}
                                            control={control}
                                            rules={{ required: false }}
                                            id="signUp-indivudal-form-card-tax-identifier"
                                            name="taxIdentifier"
                                            data={taxIdentifierData}
                                            readOnly={Boolean((props?.data?.ssn || props?.data?.itin) && props?.data?.id)}
                                            value={defaultTaxIdentifier}
                                            label="Identification Method"
                                            setValue={setValue}
                                        />
                                    </Grid>
                                    <Grid container item xs={12} sm={12} display={'flex'} alignItems="center" >
                                        <Grid item xs={isSmallScreen?11:12} sm={11}>
                                            <FxTextEditSSN
                                            key={taxIdentifier}
                                            register={{ ...register(taxIdentifier) }}
                                            className={errors.ssn || errors.itin ? "border-error-input fx-input-edit" : "fx-input-edit"}
                                            error={errors?.ssn || errors?.itin}
                                            control={control}
                                            rules={taxIdentifier === 'ssn' ? {...setSsnValidationOptions(true)} : {...setItinValidationOptions(true)}}
                                            id="signUp-indivudal-form-card-ssn-itin"
                                            label={`${taxIdentifier === 'ssn' ? 'Social Security Number' : 'Individual Taxpayer Identification Number'}`}
                                            placeholder="XXX-XX-XXXX"
                                            name={taxIdentifier}
                                            variant="outlined"
                                            setValue={setValue}
                                            setError={setError}
                                            clearErrors={clearErrors}
                                            defaultValue={props?.data?.ssn || props?.data?.itin || ''}
                                            onBlur={(e: any) => 
                                                handleAutoSave(taxIdentifier, e)
                                            }
                                            />                                   
                                        
                                        </Grid>
                                        <Grid item xs={isSmallScreen?1:12} sm={1}  container justifyContent="center" alignItems="center">
                                        {   ShowInfoToolTip('fx-business-owner-title-tooltip', 'We will use tax identifier to verify your identity and will not check your credit score', 'bottom-end')}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={isSmallScreen ? 11 : 12} sm={11} className="fx-individual-details-error-row" >
                                        <FieldErrorMessageRender error={errors} fieldKey={taxIdentifier === 'ssn' ? 'ssn' : 'itin'} />
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxLabelView id="business-owner-details-label" className="" >YOUR CONTACT INFO</FxLabelView>
                                    </Grid>
                                    <FxTextEdit register={{ ...register("address_id") }} className={"fx-hidden"} control={control} rules={{ required: false }} id="signUp-business-owner-form-card-first-name" name="address_id" variant="outlined" defaultValue={businessOwnerDetails?.address_id} />
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("addressLine1") }} className={errors.addressLine1 ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={setAddressLine1Validation} id="signUp-business-owner-addressLine1" label="Address Line 1" name="addressLine1" defaultValue={businessOwnerDetails?.addressLine1} onChange={(e: any) => { handleAddressChange(e, setValue, setError, clearErrors) }} 
                                        onBlur={(e) => handleAutoSave('addressLine1', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='addressLine1'/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("addressLine2") }} className={errors.addressLine2 ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={{ required: false }} id="signUp-business-owner-addressLine2" label="Address Line 2 (optional)" name="addressLine2" defaultValue={businessOwnerDetails?.addressLine2} 
                                        onBlur={(e) => handleAutoSave('addressLine2', e)}/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <FxTextEdit register={{ ...register("city") }} className={errors.city ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control}  rules={setCityValidation(true)} id="signUp-business-owner-city" label="City" name="city" defaultValue={businessOwnerDetails?.city}  
                                        onBlur={(e) => handleAutoSave('city', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='city'/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxMaterialSelect register={{ ...register("state") }} rules={{ required: true }} className={errors.state ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} id="signUp-business-owner-select-state" name="state" data={usa_state} label="State" setValue={setValue} value={businessOwnerDetails?.state} onChange={(e) => handleStateOnChangeEvents(e, 'state')}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='state'/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("zip") }} className={errors.zip ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={setZipValidationOptions(true)} id="signUp-business-owner-zip" label="Zip" name="zip" defaultValue={businessOwnerDetails?.zip} onChange={(e: any) => { handleZipChange(e, setValue, setError, clearErrors) }} onKeyDown={(e: any) => { handleKeyDownChange(e, setValue) }} 
                                            onBlur={(e) => handleAutoSave('zip', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='zip'/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxPhoneEdit register={register} className={errors.mobilePhone ? "border-error-input fx-input-edit" : "fx-input-edit"} control={control} rules={setPhoneValidationOptions(true)} id="signUp-business-owner-form-card-mobilePhone" label="Mobile Phone" name="mobilePhone" placeholder={'XXX-XXX-XXXX'} defaultValue={convertToPhoneDisplayFormat(businessOwnerDetails?.mobilePhone)} setValue={setValue} setError={setError} clearErrors={clearErrors} 
                                        onBlur={(e) => handleAutoSave('mobilePhone', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='mobilePhone'/>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FxTextEdit register={{ ...register("email") }} type="email" className={errors.email ? "border-error-input fx-input-edit fs-mask" : "fx-input-edit fs-mask"} control={control} rules={setEmailValidationOptions} id="signUp-business-owner-form-card-email" label="Email" name="email" variant="outlined" defaultValue={businessOwnerDetails?.email} onChange={(e: any) => { handleEmailChange(e, setValue, setError, clearErrors) }} 
                                            onBlur={(e) => handleAutoSave('email', e)}/>
                                        <FieldErrorMessageRender error={errors} fieldKey='email'/>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Divider />
                                    </Grid>
                                </Grid>
                            </FxCardBody>
                            <FxCardFooter id="signUp-business-owner-Card-Footer" className="fx-footer">
                                <Grid container direction="row" justifyContent="flex-end" className="fx-modal-footer">
                                    <FxButton
                                        disableRipple={false}
                                        variant="contained"
                                        className="fx-button fx-button-cancel"
                                        id="back-edit-business-owner-btn"
                                        onClick={handleGoBackClick}
                                    > Cancel
                                    </FxButton>
                                    <Grid className='fx-padding-right-15'></Grid>
                                    <FxButton
                                        disableRipple={false}
                                        className="fx-button fx-button-theme"
                                        id="save-edit-business-owner-btn"
                                        type="submit"
                                    > SAVE
                                    </FxButton>
                                </Grid>
                            </FxCardFooter>
                        </form>}
                    </div>
                </FxCard>
            </Grid>
        )
    }
)
